import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  companyName: null,
  clientId: null,
  exp: null,
  divisionNumber: null,
  companyDivId: null,
  isAuthenticated: false,
  userId: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // This action will receive the decoded details and update the state
    setAuthDetails: (state, action) => {
      const { token, companyName, divisionNumber, clientId, companyDivId, exp, userId } = action.payload;
      state.token = token;
      state.companyName = companyName;
      state.clientId = clientId;
      state.exp = exp;
      state.divisionNumber = divisionNumber;
      state.companyDivId = companyDivId;
      state.isAuthenticated = true;
      state.userId = userId;
    },
    clearToken: (state) => {
      state.token = null;
      state.companyName = null;
      state.clientId = null;
      state.exp = null;
      state.divisionNumber = null;
      state.companyDivId = null;
      state.isAuthenticated = false;
      state.userId = null;
    },
  },
});

export const { setAuthDetails, clearToken } = authSlice.actions;

export default authSlice.reducer;